module.exports = "https://web-assets.ifttt.com/packs/media/prosumer/image--business-circle-1-9a898edc.png";